import React from "react";

const LoadingSkeleton = ({ itemsPerPage }) => {
  return (
    <>
      {Array(itemsPerPage)
        .fill({})
        .map((_, index) => (
          <div
            key={index}
            className="flex md:space-x-6 space-x-1 justify-between items-center md:px-5 md:pr-10 md:py-4 px-1 py-2 md:my-4 border border-grey-light rounded-full animate-pulse"
          >
            <div className="md:w-7 w-3 md:h-5 h-2.5 bg-gray-300 rounded-full"></div>
            <div className="w-1/6 md:h-5 h-2.5 bg-gray-300 rounded"></div>
            <div className="w-1/6 md:h-5 h-2.5 bg-gray-300 rounded"></div>
            <div className="w-1/6 md:h-5 h-2.5 bg-gray-300 rounded"></div>
            <div className="w-1/6 md:h-5 h-2.5 bg-gray-300 rounded"></div>
            <div className="w-1/6 md:h-5 h-2.5 bg-gray-300 rounded"></div>
            <div className="w-1/6 md:h-5 h-2.5 bg-gray-300 rounded"></div>
          </div>
        ))}
    </>
  );
};

export default LoadingSkeleton;
